import { AdjustmentService } from 'src/app/shared/services/adjustments/adjustment.service';
import { DisplayNotificationService } from './../../../../shared/services/common/notification.service';
import { UsersService } from './../../../../shared/services/common/users.service';
import { Component, OnInit, Input } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { State } from '@progress/kendo-data-query';

@Component({
  selector: 'app-detailed-view',
  templateUrl: './detailed-view.component.html',
  styleUrls: ['./detailed-view.component.css']
})
export class DetailedViewComponent implements OnInit {
  gridView = [];
  gridData = [];
  adjRecord: any;
  isClicked = false;
  state: State = {
    skip: 0,
    take: 10,
    sort: []
  };

  @Input()
  set data(dataItem: any) {
    if (dataItem) {
      this.getAdjustmentRecords(dataItem);
    }
  }

  constructor(
    private router: Router,
    private usersService: UsersService,
    private adjustmentService: AdjustmentService,
    private notificationService: DisplayNotificationService
  ) { }

  ngOnInit() {
  }

  getAdjustmentRecords(data: any) {
    this.notificationService.setUpLoading(true);
    this.gridData = [];
    const inputData = { userInfo: this.usersService.UserInfo(), adjustmentId: data.id };
    this.adjustmentService.getAdjustmentV2Records(inputData).subscribe(response => {
      if (response && response.statusCode === 200) {
        if (response.invalidAdjustment && response.invalidAdjustment.length > 0) {
          response.invalidAdjustment.forEach((element: any) => {
            element.lastFourSSN = element.ssn.substr(5);
            this.gridData.push(element);
          });
        }
        if (response.validAdjustment && response.validAdjustment.length > 0) {
          response.validAdjustment.forEach((element: any) => {
            element.lastFourSSN = element.ssn.substr(5);
            this.gridData.push(element);
          });
        }
        this.gridView = this.gridData;
      } else if (response && response.statusCode === 204) {
        this.gridView = [];
      } else if (response && response.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  openRecord(record: any, isClicked: boolean) {
    this.isClicked = isClicked;
    this.adjRecord = record;
  }

  isDialogClosed(isClosed: boolean) {
    this.isClicked = isClosed;
  }

}
